export const STACKED_GRAPH_TYPES = {
  SUBMISSIONS: "submissions",
  COACH_USAGE_CHATS: "coachUsageChats",
  COACH_USAGE_STUDENTS: "coachUsageStudents"
};
